@if (isMobile()) {
  <sparrow-client-header class="flex flex-col" />
  <div class="content flex flex-auto flex-col">
    <div class="flex flex-auto flex-col content-stretch items-stretch justify-stretch">
      <router-outlet></router-outlet>
    </div>
  </div>
} @else {
  <mat-sidenav-container class="layout-container">
    <mat-sidenav
      (mouseenter)="onSidenavToggle($event)"
      (mouseleave)="onSidenavToggle($event)"
      [@onSideNavChange]="sideNavState() ? 'open' : 'close'"
      mode="side"
      opened
    >
      <sparrow-client-navbar [sideNavState]="sideNavState()" />
    </mat-sidenav>
    <mat-sidenav-content>
      @if (isRootRoute && (hasUserAnyAccess$ | async) === false) {
        <div class="flex flex-auto flex-col content-center items-center justify-center gap-4">
          <div class="pastel-green-ct"
            ><mat-icon [svgIcon]="SparrowIcon.SparrowIcon" style="width: 64px; height: 60px"
          /></div>
          <div class="sp-body-14 pastel-green-ct" i18n="@@accessRestrictedLabel">Access Restricted</div>
          <div class="sp-body-2 primary" i18n="@@contactSparrowToAddPermissionsNotice"
            >Please contact your Sparrow administrator to get permissions</div
          >
        </div>
      }
      @if (!isRootRoute) {
        <router-outlet></router-outlet>
      }
    </mat-sidenav-content>
  </mat-sidenav-container>
}
